import * as React from "react";
import { CircularProgress } from "./circular";
import { LinearProgress } from "./linear";
import type { ProgressIndicatorProps } from "./types";

/**
 * Progress Indicator component based on Material Design 3 Expressive guidelines.
 * Flexible support for 2 presentation variants: Linear and Circular,
 * with smooth dynamic Wavy shape profiles.
 *
 * @example
 * ```tsx
 * // Determinate Flat Linear
 * <ProgressIndicator variant="linear" value={60} aria-label="Loading profile..." />
 *
 * // Indeterminate Wavy Linear
 * <ProgressIndicator variant="linear" shape="wavy" aria-label="Connecting to server..." />
 *
 * // Determinate Flat Circular
 * <ProgressIndicator variant="circular" value={45} size={48} aria-label="Syncing..." />
 * ```
 */

export const ProgressIndicator = React.forwardRef<
	HTMLDivElement,
	ProgressIndicatorProps
>((props, ref) => {
	if (props.variant === "circular") {
		return <CircularProgress ref={ref} {...props} />;
	}
	return <LinearProgress ref={ref} {...props} />;
});

ProgressIndicator.displayName = "ProgressIndicator";

export type {
	CircularProgressProps,
	LinearProgressProps,
	ProgressIndicatorProps,
} from "./types";
